export default {"src":"/pro/_next/static/media/usdt.8c80fa6e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};